export default "__VITE_ASSET__30f2aa8f__"